import environment from "../../env.dev";

const googleAPIKey = environment.googleAPIKEY;
export interface CurrenciesInterface {
  name: string;
  code: string;
  symbol?: string;
  symbol_native?: string;
  name_plural?: string;
  type?: string;
  [key: string]: any;
}
export const currencies: CurrenciesInterface[] = [];

export const currencyList = [
  { code: "CAD", name: "Canadian Dollar", label: "Canadian Dollar" },
  { code: "CDF", name: "Congolesse Franc", label: "Congolesse Franc" },
  { code: "CFA", name: "West African Franc", label: "West African Franc" },
  {
    code: "CFA",
    name: "Central African Franc",
    label: "Central African Franc",
  },
  { code: "DKK", name: "Danish Krone", label: "Danish Krone" },
  { code: "ETB", name: "Ethopian Brr", label: "Ethopian Brr" },
  { code: "EUR", name: "Euro", label: "Euro" },
  { code: "GHC", name: "Ghanaian Cedi", label: "Ghanaian Cedi" },
  { code: "GBP", name: "British Pound", label: "British Pound" },
  { code: "HRK", name: "Croatian Kuna", label: "Croatian Kuna" },
  { code: "INR", name: "Indian Rupee", label: "Indian Rupee" },
  { code: "KES", name: "Kenyan Shilling", label: "Kenyan Shilling" },
  { code: "PLN", name: "Polish Zloty", label: "Polish Zloty" },
  { code: "RWF", name: "Rwandan Franc", label: "Rwandan Franc" },
  { code: "SEK", name: "Swedish Krono", label: "Swedish Krono" },
  { code: "SLL", name: "Sierra Leone leone", label: "Sierra Leone leone" },
  { code: "ZAR", name: "South African Rand", label: "South African Rand" },
  { code: "TZS", name: "Tanzanian Shilling", label: "Tanzanian Shilling" },
  { code: "UGX", name: "Ugandan Shilling", label: "Ugandan Shilling" },
  { code: "USD", name: "Dollars", label: "Dollars" },
  { code: "ZMW", name: "Zambian Kwacha", label: "Zambian Kwacha" },
];

export enum StatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PENDING = "pending",
  DISABLED = "disable",
}

const fetchGoogleFonts = async (): Promise<string[]> => {
  try {
    const response = await fetch(
      `https://www.googleapis.com/webfonts/v1/webfonts?key=${googleAPIKey}`
    );
    const data = await response.json();
    const fontList: string[] = data.items.map(
      (item: { family: string }) => item.family
    );
    return fontList;
  } catch (error) {
    console.error("Error fetching Google Fonts:", error);
    return [];
  }
};

export default fetchGoogleFonts;

export const sizes = ["8", "10", "12", "14", "16", "18", "20"];
